import {ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getAuth, provideAuth} from '@angular/fire/auth';
import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {jwtInterceptor} from "./interceptors/jwt.interceptor";
import {AuthService} from "./services/auth.service";

function initializeAuth(authService: AuthService) {
  return () => authService.initializeToken();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([jwtInterceptor])
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true
    }
  ]
};
